import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Paginator } from '../../../../models/Paginator';
import { ADMIN_ENTITIES, ENTITY_METADATA, EntityConfig, EntityMetadata } from './configs/entity-registry';

@Component({
  selector: 'app-unified-admin',
  standalone: true,
  imports: [CommonModule, GenericCrudComponent],
  templateUrl: './unified-admin.component.html',
  styleUrl: './unified-admin.component.css'
})
export class UnifiedAdminComponent implements OnInit {
  @ViewChild(GenericCrudComponent) genericCrudComponent!: GenericCrudComponent;

  entities: EntityMetadata[] = ENTITY_METADATA;
  activeEntityId: string = 'banks';
  currentConfig: EntityConfig | null = null;
  genericCRUD: GenericCRUD<Paginator<any>> | null = null;

  private pendingPrefill: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Leer entidad desde query params o default a 'banks'
    this.route.queryParams.subscribe(params => {
      const entityId = params['entity'] || 'banks';
      this.loadEntity(entityId);

      // Detectar parámetros de pre-fill (tras crear rectificativa)
      if (params['action'] === 'create' && params['prefill_user_id']) {
        const prefillData: any = { user_id: +params['prefill_user_id'] };
        if (params['prefill_company_id']) {
          prefillData.company_id = +params['prefill_company_id'];
        }
        this.pendingPrefill = prefillData;

        // Limpiar params de la URL
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { entity: entityId },
        });

        // Abrir formulario con prefill tras renderizado
        setTimeout(() => this.openFormWithPrefill(), 300);
      }
    });
  }

  /**
   * Abre el formulario de creación con datos pre-rellenados
   */
  private openFormWithPrefill(): void {
    if (!this.pendingPrefill || !this.genericCrudComponent) return;

    if (!this.genericCrudComponent.activeForm) {
      this.genericCrudComponent.selectedItemFromTable = this.pendingPrefill;
      this.genericCrudComponent.activeFormFromTable = false;
      this.genericCrudComponent.activeForm = true;
    }
    this.pendingPrefill = null;
  }

  /**
   * Carga la configuración de una entidad y construye el objeto GenericCRUD
   */
  loadEntity(entityId: string): void {
    const config = ADMIN_ENTITIES[entityId];

    if (!config) {
      console.error(`Entity configuration not found for: ${entityId}`);
      // Volver a banks si la entidad no existe
      this.loadEntity('banks');
      return;
    }

    this.activeEntityId = entityId;
    this.currentConfig = config;

    // Deep copy para evitar mutación de las configuraciones originales
    const formCopy = { ...config.form, fields: [...config.formFields] };
    const tableCopy = {
      ...config.table,
      columns: [...config.tableColumns],
      actions: [...config.tableActions]
    };

    // Construir configuración de GenericCRUD
    this.genericCRUD = {
      genericForm: formCopy,
      genericTable: tableCopy,
      genericFilters: [...config.filters],
      useModalForm: config.useModalForm,
      createRoute: config.createRoute
    };

    // Actualizar URL sin recargar la página
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { entity: entityId },
      queryParamsHandling: 'merge'
    });
  }

  /**
   * Manejador de cambio de entidad desde los tabs
   */
  onEntityChange(entityId: string): void {
    this.loadEntity(entityId);
  }

  /**
   * Verifica si una entidad está activa
   */
  isActiveEntity(entityId: string): boolean {
    return this.activeEntityId === entityId;
  }
}
